<template>
  <LoadingElement></LoadingElement>
  <div v-for="(modal, index) in modalList" :key="index">
    <ModalElement :modal="modal" :index="index"></ModalElement>
  </div>
  <div class="app" :lang="currentLanguageId">
    <router-view />
  </div>
  <FooterElement></FooterElement>
</template>
<script setup>
import { useFlagStore } from '@/store';
import FooterElement from './components/FooterElement.vue';
import LoadingElement from './components/LoadingElement.vue';
import ModalElement from './components/ModalElement.vue';
import { onMounted, computed, onUnmounted } from 'vue';
import { speechrecognition } from '@/plugins/speechrecognition';

defineOptions({
  name: 'App',
});
const store = useFlagStore();
const modalList = store.getModalList;
const currentLanguageId = computed(() => store.currentLanguageId);

const stopSpeech = () => {
  if (speechrecognition.isRecognising?.value) {
    speechrecognition.stopRecognition();
  }
};

onMounted(async () => {
  store.showLoading(true);

  if (!window.SpeechRecognition && !window.webkitSpeechRecognition) {
    store.setModal({
      content:
        'Speechrecognition is not supported on this browser. You will not be able to play this game.',
      title: '',
      eventName: 'nodutch',
      type: 'notification',
    });
  } else {
    store.setSpeechPossibility(true);
  }

  window.addEventListener('beforeunload', stopSpeech); //does not work on iOS/Safari
  window.addEventListener('pagehide', stopSpeech); // for iOS/Safari

  // Optional: also handle visibility change
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') {
      stopSpeech();
    }
  });
  store.showLoading(false);
});

onUnmounted(() => {
  window.removeEventListener('beforeunload', stopSpeech);
  window.removeEventListener('pagehide', stopSpeech);
  document.removeEventListener('visibilitychange', stopSpeech);
});
</script>
<style lang="scss">
#app {
  display: flex;
  flex-direction: column;
  font-family: Parkinsans, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: white;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: white;

    &.router-link-exact-active {
      color: var(--blue);
      text-decoration: none;
      cursor: default;
    }
    &:hover {
      color: var(--blue);
    }
  }
}
</style>
